import React, { useEffect } from 'react';
import ContactList from '../components/chat/ContactList';
import Messages from '../components/chat/Messages';
import useChat from '../hooks/useChat';


const ChatPage: React.FC = () => {

    const { activeConversation, activeChatPartner, setFirstConversationActive } = useChat();
    useEffect(() => {
        if (!activeConversation && !activeChatPartner) {
            setFirstConversationActive();
        }
    }, []); // Empty dependency array means this effect runs once on mount and cleanup on unmount


    return (
        // height is 100vh - amount of navbar pixels
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row h-[calc(100vh-80px)]">
            <div className={`md:w-1/3 transition-transform duration-300 h-full overflow-y-auto ${true ? 'translate-x-0' : 'translate-x-full md:translate-x-0'}`}>
                <ContactList />
            </div>
            <div className="md:w-2/3 flex-grow flex flex-col h-full">
                <Messages />
            </div>
        </div>

    );
};

export default ChatPage;
